export default __webpack_public_path__ + "static/media/empathy-sm.54a3d920.jpg";